import { render } from "./ServiceCallForm.vue?vue&type=template&id=6af33cb1"
import script from "./ServiceCallForm.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./ServiceCallForm.vue?vue&type=script&charset=utf-8&lang=js"
script.render = render

export default script